module.exports = __webpack_public_path__ + "img/pay (7).94ae020d.png";